var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_vm._t("image",function(){return [_c('Skeleton',{staticClass:"image"})]}),_vm._t("desc",function(){return [_c('Skeleton',{staticClass:"desc"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }